import {BasicCriteria} from '../../framework/parameters/BasicCriteria';

export class BusinessUnitCriteria extends BasicCriteria {
manageDeactivated: boolean | null;
nameLike: string;
}

